import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Recent-register filter: a picked day shows that day; no date shows the latest 25.
export const RECENT_LIMIT = 25;
export function recentEntries(list, filterDate) {
  const key = (t) => t.date || t.created_at || '';
  if (filterDate) return list.filter(t => key(t).slice(0, 10) === filterDate);
  return [...list].sort((a, b) => key(b).localeCompare(key(a))).slice(0, RECENT_LIMIT);
}
